import { ToggleSwitchStyles } from "./toggleSwitch.styles";

const ToggleSwitch = ({ className, style, value, name, handleChange }) => {
  const toggle = () => handleChange(name, !value);

  return (
    <ToggleSwitchStyles
      className={className}
      style={style}
      $active={value}
      onClick={toggle}
    >
      <div
        className="toggleTrack"
        role="switch"
        aria-checked={value}
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle();
          }
        }}
      />
    </ToggleSwitchStyles>
  );
};

export default ToggleSwitch;
